













import Vue from 'vue';
import VePie from 'v-charts/lib/pie.common';
import 'echarts/lib/component/title';
import customerClient from '../../../apis';
import customerVuex from '../../../vuex/common';

export default Vue.extend({
  mixins: [customerVuex],
  components: {
    VePie,
  },
  data() {
    return {
      legend: {
        bottom: 20,
        data: [
          {name: '简体中文', icon: 'circle'},
          {name: '英文', icon: 'circle'},
          {name: '繁体中文', icon: 'circle'},
          {name: '其他', icon: 'circle'},
        ],
        itemWidth: 8,
      },
      chartSettings: {
        limitShowNum: 5,
        radius: 80,
        label: {
          formatter: '{b} : {d}%',
          textStyle: {
            color: '#000',
          },
        },
        hoverAnimation: false,
        itemStyle: {
          borderColor: '#fff',
          borderWidth: 2,
        },
        labelMap: {
          count: '人数',
        },
      },
      title: {
        text: '粉丝语言比例',
        left: 'center',
        top: 50,
        textStyle: {
          color: '#000',
          fontSize: 14,
        },
      },
      tooltip: {
        show: false,
      },
      colors: ['#00A287', '#59CB74', '#F0B738', '#48A1FF'],
      chartData: {
        columns: ['language', 'count'],
        rows: [],
      },
      loading: true,
    };
  },
  methods: {
    getCount(datas: any, type: any) {
      const data = datas.find((d: any) => d.language === type);
      if (data) {
        return data.count;
      } else {
        return 0;
      }
    },
    getLanguageData() {
      customerClient.getLanguageGroup(this.customerState.customerQuery).success((r) => {
        if (r.data) {
          const sum = r.data.map((d: any) => d.count).reduce((a: number, b: number) => a + b, 0);
          this.chartData.rows = [ 
            { language: '简体中文', count: this.getCount(r.data, 'zh_CN') },
            { language: '英文', count: this.getCount(r.data, 'en') },
            { language: '繁体中文', count: this.getCount(r.data, 'zh_TW') },
            { language: '其他', count: r.total - sum },
          ];
          this.loading = false;
        }
      }).error((e) => {
        this.$Message.error(e.toString());
      });
    },
  },
  mounted() {
    this.getLanguageData();
  },
});

